/**
 * Created by olga on 28.01.2025
 */

cleverapps.InitByType["yatzy"] = function () {
    cleverapps.tutorial.register(BasicsTutorial());
    cleverapps.tutorial.register(ComboTutorial());
    cleverapps.tutorial.register(ProlongationTutorial());
};